<template>
  <div class="user-manage">
    <el-card>
      <div slot="header" class="card-header">
        <span>用户信息管理（users）</span>
      </div>

      <el-form :inline="true" :model="query" class="filter-form">
        <el-form-item label="openid">
          <el-input v-model="query.openid" placeholder="按 openid 搜索" clearable size="small" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="query.nickname" placeholder="按昵称搜索" clearable size="small" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="fetchList(1)">查询</el-button>
          <el-button size="small" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="avatar_url" label="头像" width="100">
          <template slot-scope="scope">
            <el-avatar :src="scope.row.avatar_url" size="small" />
          </template>
        </el-table-column>
        <el-table-column prop="openid" label="openid" min-width="160" />
        <el-table-column prop="nickname" label="昵称" min-width="100" />
        <el-table-column prop="phone" label="手机号" width="120" />
        <el-table-column prop="points" label="积分" width="90" />
        <el-table-column prop="is_banned" label="封禁状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_banned === 1" type="danger" size="small">已封禁</el-tag>
            <el-tag v-else type="success" size="small">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" min-width="160" />
        <el-table-column prop="updated_at" label="更新时间" min-width="160" />
        <el-table-column label="操作" fixed="right" width="260">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">详情</el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleBan(scope.row)"
            >
              {{ scope.row.is_banned === 1 ? '解封' : '封禁' }}
            </el-button>
            <el-button type="text" size="small" @click="handleAdjustPoints(scope.row)">调整积分</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          background
          layout="sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :page-sizes="[5 ,10, 20, 50, 100]"
          :current-page.sync="page"
          :total="total"
          @current-change="fetchList"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <el-dialog title="用户详情" :visible.sync="detailVisible" width="500px">
      <el-descriptions v-if="current" :column="1" size="small" border>
        <el-descriptions-item label="ID">{{ current.id }}</el-descriptions-item>
        <el-descriptions-item label="openid">{{ current.openid }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ current.nickname }}</el-descriptions-item>
        <el-descriptions-item label="头像">
          <el-avatar :src="current.avatar_url" />
        </el-descriptions-item>
        <el-descriptions-item label="手机号">{{ current.phone }}</el-descriptions-item>
        <el-descriptions-item label="积分">{{ current.points }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ current.created_at }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ current.updated_at }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="调整积分" :visible.sync="adjustVisible" width="420px">
      <el-form :model="adjustForm" :rules="adjustRules" ref="adjustFormRef" label-width="100px">
        <el-form-item label="openid">
          <el-input v-model="adjustForm.openid" disabled />
        </el-form-item>
        <el-form-item label="积分变动" prop="points">
          <el-input-number
            v-model="adjustForm.points"
            :min="-999999"
            :max="999999"
            :step="1"
            controls-position="right"
            style="width: 100%"
          />
          <div class="tips">正数增加，负数扣减；恶意发布请选择类型 4</div>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="adjustForm.type" placeholder="请选择积分类型">
            <el-option :value="1" label="每日浏览" />
            <el-option :value="2" label="分享商品" />
            <el-option :value="3" label="发布商品" />
            <el-option :value="4" label="恶意发布（扣分）" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adjustVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdjust">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/utils/http'

function formatDateArray (arr) {
  if (!Array.isArray(arr) || arr.length < 6) return ''
  const [y, M, d, h, m, s] = arr
  const pad = n => (n < 10 ? '0' + n : '' + n)
  return `${y}-${pad(M)}-${pad(d)} ${pad(h)}:${pad(m)}:${pad(s)}`
}

export default {
  name: 'UserManage',
  data () {
    return {
      loading: false,
      list: [],
      allList: [],
      page: 1,
      pageSize: 5,
      total: 0,
      query: {
        openid: '',
        nickname: ''
      },
      detailVisible: false,
      current: null,
      adjustVisible: false,
      adjustForm: {
        openid: '',
        points: -1,
        type: 4
      },
      adjustRules: {
        points: [
          { required: true, message: '请输入积分变动值', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === 0 || value === null || value === undefined) {
              callback(new Error('积分变动不能为 0'))
            } else {
              callback()
            }
          }, trigger: 'change' }
        ],
        type: [{ required: true, message: '请选择积分类型', trigger: 'change' }]
      }
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList (page = this.page) {
      this.page = page
      this.loading = true
      try {
        // 这里演示直接请求 /get，后端返回 { code, message, data: [...] }
        const res = await http.get('/api/users')
        // http 封装已帮你把 data 提出来，这里的 res 就是 data 数组
        const rows = Array.isArray(res) ? res : []

        // 将后端字段映射到表格使用的字段
        this.allList = rows.map(item => ({
          id: item.id,
          openid: item.openid,
          nickname: item.nickname,
          avatar_url: item.avatarUrl, // 注意：后端是 avatarUrl
          phone: item.phone,
          points: item.points,
          is_banned: item.isBanned, // 后端: isBanned 0/1
          created_at: formatDateArray(item.createdAt),
          updated_at: formatDateArray(item.updatedAt)
        }))
        this.total = this.allList.length
        const start = (this.page - 1) * this.pageSize
        this.list = this.allList.slice(start, start + this.pageSize)
      } catch (e) {
        this.$message.error(e.message || '获取用户列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.page = 1
      const start = 0
      this.list = this.allList.slice(start, start + this.pageSize)
    },
    resetQuery () {
      this.query.openid = ''
      this.query.nickname = ''
      this.fetchList(1)
    },
    handleView (row) {
      this.current = Object.assign({}, row)
      this.detailVisible = true
    },
    handleAdjustPoints (row) {
      this.adjustVisible = true
      this.adjustForm = {
        openid: row.openid,
        points: -1,
        type: 4
      }
      this.$nextTick(() => {
        this.$refs.adjustFormRef && this.$refs.adjustFormRef.clearValidate()
      })
    },
    submitAdjust () {
      this.$refs.adjustFormRef.validate(async valid => {
        if (!valid) return
        const payload = {
          openid: this.adjustForm.openid,
          points: this.adjustForm.points,
          type: this.adjustForm.type
        }
        try {
          await http.post('/api/user-points-records', payload)
          this.$message.success('积分调整成功')
          this.adjustVisible = false
          this.fetchList(this.page)
        } catch (e) {
          this.$message.error(e.message || '积分调整失败')
        }
      })
    },
    async handleBan (row) {
      const name = row.nickname || row.openid || row.id
      const targetStatus = row.is_banned === 1 ? 0 : 1
      const actionText = targetStatus === 1 ? '封禁' : '解封'

      try {
        await this.$confirm(`确认${actionText}用户「${name}」吗？`, '提示', {
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        // 调用后端封禁/解封接口：PUT /users/{id}/ban?banStatus=1|0
        await http.put(`/api/users/${row.id}/ban`, null, {
          params: { banStatus: targetStatus }
        })

        // 本地更新状态，避免再次请求列表
        row.is_banned = targetStatus
        const idx = this.allList.findIndex(u => u.id === row.id)
        if (idx !== -1) {
          this.$set(this.allList, idx, {
            ...this.allList[idx],
            is_banned: targetStatus
          })
        }

        this.$message.success(`用户${actionText}成功`)
      } catch (e) {
        this.$message.error(e.message || `用户${actionText}失败`)
      }
    }
  }
}
</script>

<style scoped>
.user-manage {
  min-height: 300px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-form {
  margin-bottom: 10px;
}

.pager {
  margin-top: 16px;
  text-align: right;
}
</style>
